import { createSelector } from 'reselect'
import { getByIdExerciseSelector } from '@gymaholic/packages'
import getMusclesWorkedStrByIdExerciseSelectorUtil from 'modules/exercise/redux/selectors/get-muscles-worked-str-by-id/utils/index.js'

function getMusclesWorkedStrByIdExerciseSelector ({
  id,
  intl
}) {
  return createSelector(
    getByIdExerciseSelector(id),
    (exercise) => getMusclesWorkedStrByIdExerciseSelectorUtil({
      exercise,
      intl
    })
  )
}

export default getMusclesWorkedStrByIdExerciseSelector
